export enum NotificationProvider {
  CustomerIO,
  None,
}

type NotificationMap = {
  [key in NotificationProvider]: {
    path: string | undefined;
    identifyUser: (id: number) => void;
    resetUser: () => void;
  };
};

export const notificationsMap: NotificationMap = {
  [NotificationProvider.CustomerIO]: {
    path: '/pixels/customer-io.js',
    identifyUser: (id: number) => {
      try {
        // @ts-ignore
        _cio?.identify({
          id: `luckyelfcasino:${id}`,
        });
      } catch {}
    },
    resetUser: () => {
      try {
        // @ts-ignore
        _cio?.reset();
      } catch {}
    },
  },
  [NotificationProvider.None]: {
    path: undefined,
    identifyUser: () => {},
    resetUser: () => {},
  },
};
